import React from "react";
import Sidebar from "./Sidebar";
import { motion } from "framer-motion";

export default function Navbar() {
  const menuItems = [
    {
      title: "แผนที่",
      text: "ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ",
      icon: "fa fa-location-dot",
      onClick: () =>
        window.open("https://maps.app.goo.gl/LpiqZSDmeuqHaoue8", "_blank"),
    },
    {
      title: "เวลาทำการ",
      text: "วันจันทร์ - ศุกร์ เวลา 08:30 - 20:30 น.\nวันเสาร์ - อาทิตย์ เวลา 08:30 - 16:30 น.",
      icon: "fa fa-clock",
    },
    // {
    //   title: "ติดต่อ",
    //   text: "098 458 2500, 053 948 031, 053 948 112",
    //   icon: "fa fa-phone",
    //   onClick: () => window.open("tel:053948031"),
    // },
  ];
  return (
    <>
      <div className="lg:block hidden min-w-screen mx-auto">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="h-full flex justify-between items-center py-5 px-10"
        >
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex justify-start items-center space-x-4"
          >
            <div className="w-[100px]">
              <img
                src="/images/logo/logoN.png"
                className="object-cover"
                alt="Logo"
              />
            </div>
            <div className="flex flex-col justify-start items-start">
              <div className="flex space-x-2 text-3xl">
                <span className="font-bold text-[#0F4D81]">NOVEL</span>
                <span className="font-bold text-[#9E76B3]">CMU</span>
              </div>
              <span className="text-[6px] text-[#8F939A]">
                NORTHERN REGIONAL VETERINARY HEALTHCARE AND LEARNING CENTER
              </span>
              <span className="text-[14px] text-[#0F4D81]">
                ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
              </span>
            </div>
          </motion.div>

          {/** แอนิเมชันสำหรับแต่ละกล่องเมนู */}
          {menuItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
              onClick={item.onClick}
              className="flex flex-col gap-1 border-r-2 rounded-l-md p-4 hover:cursor-pointer hover:shadow-lg transition-all duration-300 ease-in-out"
            >
              <div className="flex justify-end">
                <span className="font-bold text-[#0F4D81]">{item.title}</span>
              </div>
              <div className="flex justify-between items-center space-x-7">
                <div className="border-dashed border-2 border-[#0F4D81] px-2 py-1">
                  <i className={item.icon + " text-[#0F4D81]"}></i>
                </div>
                <span className="text-gray-400">{item.text}</span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
      <Sidebar />
    </>
  );
}
